import React from 'react';

/**
 * Pill-shaped segmented control — a single tab-strip toggle between mutually
 * exclusive options, replacing a row of separate filter buttons.
 */
export function SegmentedControl({ options, value, onChange, className = '' }) {
  return (
    <div
      role="tablist"
      className={`inline-flex items-center gap-1 rounded-lg border border-brand-200 bg-brand-100 p-1 ${className}`}
    >
      {options.map((option) => {
        const active = option.value === value;
        return (
          <button
            key={option.value}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange(option.value)}
            className={[
              'rounded-md px-3 py-1.5 text-xs font-medium transition-all duration-150',
              active
                ? 'bg-brand-500 text-white shadow-sm'
                : 'text-slate-600 hover:bg-white hover:text-brand-600',
            ].join(' ')}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}

export default SegmentedControl;
